<template>
  <div
    class="h-100 position-absolute measure_point p-10"
    id="history"
    v-if="showListData"
    v-drag
    :body-style="{ padding: '10px' }"
    :style="{ left: isShowBasicCom ? '405px' : '35px' }"
  >
    <el-row class="c-white business_dialog_title m-b-5">
      <el-col :span="12" class="fz-14">测点数据</el-col>
      <el-col :span="12">
        <i @click="closePoint" class="cur_pointer fz-12 iconfont icon-close r"></i>
      </el-col>
    </el-row>
    <el-card class="w-100" :body-style="{ height: '100%' }">
      <!-- 时间 -->
      <el-row class="flex-align-center d-flex m-b-10">
        <el-col :span="12">
          <el-select
            v-model="measurePoint"
            placeholder="--请选择--"
            size="mini"
            class="w-100"
            popper-class="document_select-popper"
            filterable
            clearable
          >
            <el-option
              v-for="item in temporallyPointList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="12" class="tr">
          <el-button
            size="mini"
            type="primary"
            class="m-l-10"
            icon="iconfont icon-add"
            data-cy="searchBtn"
            @click="addMeasurePoint"
            v-buttonMonitor="{ name: '加入', operate: 'update' }"
            >加入测点</el-button
          >
        </el-col>
      </el-row>
      <!-- 表格 -->
      <el-table :data="tableData" v-loading="tableLoading" class="data w-100" height="100px">
        <el-table-column label="序号">
          <template slot-scope="scope">{{ scope.$index + 1 }}</template>
        </el-table-column>
        <el-table-column prop="name" label="测点名称"></el-table-column>
        <el-table-column prop="code" label="测点编码"></el-table-column>
        <el-table-column label="是否显示" align="center">
          <template #default="{row}">
            <div
              @click="
                (e) => {
                  e.stopPropagation()
                }
              "
            >
              <el-checkbox
                v-model="row.isShow"
                @change="(e) => changeMeasurePointShow(e, row)"
              ></el-checkbox>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 时间 -->
      <el-row class="flex-align-center d-flex">
        <el-col :span="18">
          <el-date-picker
            class="time w-100"
            type="daterange"
            v-model="dateTimes"
            size="mini"
            popper-class="document_select-popper"
            range-separator="~"
            value-format="yyyy-MM-dd"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
          ></el-date-picker>
        </el-col>
        <el-col :span="6" class="tr">
          <el-button
            size="mini"
            type="primary"
            icon="iconfont icon-search"
            data-cy="searchBtn"
            @click="searchHistoryData"
            v-buttonMonitor="{ name: '查询', operate: 'read' }"
            >搜索</el-button
          >
        </el-col>
      </el-row>

      <!-- echarts -->
      <div class="w-100 flex charts position-relative">
        <v-chart
          :options="historyChart"
          :autoresize="false"
          class="h-100"
          theme="macarons"
          id="history-chart"
        />
      </div>
    </el-card>
  </div>
</template>
<script>
import ApiMixinPoint from '@/assets/js/api/measuringPoint'

export default {
  name: 'MeasurePoint',
  props: {
    player: {
      type: Object,
      default: () => {
        return {}
      },
    },
    isShowBasicCom: {
      type: Boolean,
      defalut: false,
    },
  },
  mixins: [ApiMixinPoint],
  data() {
    return {
      dateTimes: [
        moment()
          .subtract(6, 'days')
          .format('YYYY-MM-DD'),
        moment().format('YYYY-MM-DD'),
      ],
      tableData: [],
      showListData: false, // 显示历史数据
      markerInfo: [], // 标签信息
      markerList: [], // 点击标记添加信息
      tableLoading: false,
      labelCode: [],
      measurePoint: '', // 加入测点信息
      temporallyPointList: [], // 临时测点数据
      measurePointList: [], // 所有测点信息
      historyChart: {
        color: [],
        title: {
          text: '测点历史数据',
          textStyle: {
            color: '#ffffff',
            fontSize: '12px',
          },
        },
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(255,255,255,0.7)',
          textStyle: {
            color: '#000',
          },
        },
        grid: {
          left: '4%',
          right: '5%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: [],
          axisLine: {
            lineStyle: {
              color: '#ffffff',
            },
          },
          axisLabel: {
            interval: 0,
            rotate: 20,
            textStyle: {
              color: '#ffffff',
            },
          },
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            textStyle: {
              color: '#ffffff',
            },
          },
          axisLine: {
            lineStyle: {
              color: '#ffffff',
            },
          },
        },
        series: [],
      },
      dialogLeft: '35px', // 弹框距离左侧位置
    }
  },
  async created() {
    await this.getMeasurePoints()
    this.player.Native.GisMarker.EventGisMarkerLClick.connect(this.clickMarker)
  },
  watch: {},
  computed: {
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
    // 获取显示数据
    getFormatterData() {
      return (id, mark) => {
        if (id) {
          const currentData = _.find(this.historyChart.series, ['id', id])
          if (currentData) {
            return `${mark}<span style='color:#F56C6C'>最大值：${currentData.max}</span>
          <br/>${mark}<span style='color:#409EFF'>最小值：${currentData.min}</span>
          <br/>${mark}<span style='color:#67C23A'>平均值：${currentData.average}</span>`
          }
          return ''
        }
        return ''
      }
    },
  },
  beforeDestroy() {
    this.destroyMarker()
  },
  methods: {
    searchHistoryData() {
      this.tableData = _.map(this.tableData, (item) => {
        const historyData = []
        _.times(moment(this.dateTimes[1]).diff(this.dateTimes[0], 'days') + 1, () => {
          historyData.push(_.random(100, 2000))
        })
        return { ...item, isShow: true, historyData }
      })
      this.historyChart.series = _.map(this.tableData, (item) => {
        return {
          id: item.id,
          name: `${item.tagCode}-${item.name}(单位:${item.unit || ''})`,
          type: 'line',
          symbolSize: [8, 8],
          data: item.historyData,
          max: _.max(item.historyData),
          min: _.min(item.historyData),
          average: _.mean(item.historyData).toFixed(2),
        }
      })
      this.historyChart.xAxis.data = []
      if (this.dateTimes && this.dateTimes.length >= 2) {
        for (let i = 0; i <= moment(this.dateTimes[1]).diff(this.dateTimes[0], 'days'); i += 1) {
          this.historyChart.xAxis.data.push(
            moment(this.dateTimes[0])
              .add(i, 'days')
              .format('MM-DD')
          )
        }
      }
    },
    async destroyMarker() {
      // 检查是否有已知的标记
      _.forEach(this.markerInfo, async (el) => {
        if (el.markerId) {
          await this.player.Native.GisMarker.destroy(el.markerId)
          el.markerId = null
        }
      })
    },
    closePoint() {
      this.tableData = []
      this.dateTimes = this.$options.data().dateTimes
      this.historyChart = this.$options.data().historyChart
      this.showListData = false
    },
    // 是否展示所选测点
    changeMeasurePointShow(val, row) {
      if (val) {
        this.historyChart.series.push({
          id: row.id,
          name: `${row.tagCode}-${row.name}(单位:${row.unit || ''})`,
          type: 'line',
          symbolSize: [8, 8],
          data: row.historyData,
          max: _.max(row.historyData),
          min: _.min(row.historyData),
          average: _.mean(row.historyData).toFixed(2),
        })
      } else {
        const chartDom = document.getElementById('history-chart')
        const chart = this.$echarts.init(chartDom)
        _.remove(this.historyChart.series, ['id', row.id])
        chart.setOption(this.historyChart, true)
      }
    },
    // 加入测点
    addMeasurePoint() {
      if (!this.measurePoint) {
        this.$message.warning('请选择测点！')
        return
      }
      const addData = _.find(this.temporallyPointList, ['id', this.measurePoint])
      addData.historyData = []
      _.times(moment(this.dateTimes[1]).diff(this.dateTimes[0], 'days') + 1, () => {
        addData.historyData.push(_.random(100, 2000))
      })
      if (addData) {
        const tableIndex = _.findIndex(this.tableData, ['id', this.measurePoint])
        if (tableIndex !== -1) {
          this.tableData[tableIndex].isShow = true
        } else {
          this.tableData.push({ ...addData, isShow: true })
        }
        const seriesIndex = _.findIndex(this.historyChart.series, ['id', addData.id])
        if (seriesIndex === -1) {
          this.historyChart.series.push({
            id: addData.id,
            name: `${addData.tagCode}-${addData.name}(单位:${addData.unit || ''})`,
            type: 'line',
            symbolSize: [8, 8],
            data: addData.historyData,
            max: _.max(addData.historyData),
            min: _.min(addData.historyData),
            average: _.mean(addData.historyData).toFixed(2),
          })
        }
      }
    },
    // 绘制标签
    async drawLabel(code, text, length, height) {
      // 如果该模型上已有标记则返回
      if (!_.isEmpty(this.labelCode) && this.labelCode.includes(code)) {
        return
      }
      this.labelCode.push(code)
      const resPtr = await PlayerUtils.call(this.player.Native.ModelTree.calcItemAabb, code)
      const pos = []
      if (!_.isEmpty(resPtr)) {
        pos[0] = 1 * resPtr.aabb.min[0] + (resPtr.aabb.max[0] - resPtr.aabb.min[0]) / 2 // x坐标
        pos[1] = 1 * resPtr.aabb.min[1] + (resPtr.aabb.max[1] - resPtr.aabb.min[1]) / 2 // y坐标
        pos[2] = 1 * resPtr.aabb.min[2] + (resPtr.aabb.max[2] - resPtr.aabb.min[2]) / 2 // z坐标
        const imgId = await PlayerUtils.call(
          this.player.Native.GisMarker.loadImage,
          `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/tag_info.png`
        )
        const option = {
          pos, // 定位点，世界坐标，三维向量
          text, // 文本
          visible: true, // 显示隐藏状态
          size: -1, // 整体尺寸，二维向量，-1表示不限制，自动大小
          nodeOffset: [(-1 * (length * 10 - 40)) / 2, -1 * height * 24 - 10], // 相对定位点的偏移量，二维向量
          imgId, // 图片
          imgSize: [-1, -1], // 图片尺寸，-1为应用图片大小，如[32, -1]为宽度拉伸或压缩到32，高度为图片高度
          imgOffset: [(-1 * (length * 10)) / 2, -1 * height * 24], // 图片相对标记的偏移量
          fontSize: 18.0, // 字体大小
          breakWidth: -1, // 最大行宽，超过宽度会换行，-1表示限制，换行符（'\n'）会强制换行不受控制
          contentPadding: [10, 25, 0, 0], // 文字相对标记的偏移量
          textColor: 0xffffffff, // 文本颜色
          title: '', // 标题
          titleFontSize: 18.0, // 标题文字大小
          titleColor: 0xffffffff, // 标题颜色
          userData: null, // 用户数据，仅帮外部系统保存数据
        }
        // option里面的类容均为可选，但是option至少是{}，不能为null
        const markerId = await PlayerUtils.call(this.player.Native.GisMarker.create, option)
        this.markerInfo.push({ markerId, code })
      }
    },
    // 点击标签
    async clickMarker(e) {
      // 获取点击标记所在模型code
      const info = _.find(this.markerInfo, ['markerId', e.markerId])
      if (info) {
        this.historyChart = this.$options.data().historyChart
        this.dateTimes = this.$options.data().dateTimes
        await this.getTableData(info.code)
        this.showListData = true
        this.dialogLeft = this.isShowBasicCom ? '405px' : '35px'
        this.temporallyPointList = _.filter(this.measurePointList, (item) => {
          return _.findIndex(this.tableData, ['id', item.id]) === -1
        })
      }
    },
    // 获取所有测点
    async getMeasurePoints() {
      const params = {
        siteId: this.currentProject.id,
        bind: true,
        pageno: 1,
        pagesize: 9999,
      }
      const res = await this.apiPoint({
        method: 'list',
        params,
      })
      if (res && res.code === 0 && res.data) {
        this.measurePointList = res.data
        _.forEach(res.data, (item) => {
          // 将相同模型关联的测点提前出来
          const sameMarkerName = _.filter(res.data, (el) => {
            return el.tagCode === item.tagCode
          })
          if (sameMarkerName.length > 1) {
            // 将相同模型关联的测点名称集合起来作为标记文本
            const labelName = _.map(sameMarkerName, (v) => {
              return `${v.name}:${_.random(100, 1000)}${v.unit || ''}`
            })
            labelName.unshift(`KKS:${item.tagCode}`)
            const textMaxLength = _.max(
              _.map(labelName, (i) => {
                return i.length
              })
            )
            this.drawLabel(item.tagCode, labelName.join('\n'), textMaxLength, labelName.length)
          } else {
            const labelName = [
              `KKS:${item.tagCode}`,
              `${item.name}:${_.random(100, 1000)}${item.unit || ''}`,
            ]
            const textMaxLength = _.max(
              _.map(labelName, (i) => {
                return i.length
              })
            )
            console.log(labelName, textMaxLength)
            this.drawLabel(item.tagCode, labelName.join('\n'), textMaxLength, 2)
          }
        })
      }
    },
    async getTableData(code) {
      this.tableLoading = true
      this.tableData = []
      const params = {
        siteId: this.currentProject.id,
        tagCode: code,
        bind: true,
        pageno: 1,
        pagesize: 9999,
      }
      const res = await this.apiPoint({
        method: 'list',
        params,
      })
      this.tableLoading = false
      if (res && res.code === 0 && res.data) {
        this.tableData = _.map(res.data, (item) => {
          const historyData = []
          _.times(moment(this.dateTimes[1]).diff(this.dateTimes[0], 'days') + 1, () => {
            historyData.push(_.random(100, 2000))
          })
          return { ...item, isShow: true, historyData }
        })
        this.historyChart.series = _.map(this.tableData, (item) => {
          return {
            id: item.id,
            name: `${item.tagCode}-${item.name}(单位:${item.unit || ''})`,
            type: 'line',
            symbolSize: [8, 8],
            data: item.historyData,
            max: _.max(item.historyData),
            min: _.min(item.historyData),
            average: _.mean(item.historyData).toFixed(2),
          }
        })
        if (this.dateTimes && this.dateTimes.length >= 2) {
          this.historyChart.xAxis.data = []
          for (let i = 0; i <= moment(this.dateTimes[1]).diff(this.dateTimes[0], 'days'); i += 1) {
            this.historyChart.xAxis.data.push(
              moment(this.dateTimes[0])
                .add(i, 'days')
                .format('MM-DD')
            )
          }
        }
        this.historyChart.tooltip.formatter = (data) => {
          return `<b>${data.seriesName}</b><br/>${data.marker}实时值：${
            data.value
          }<br/>${this.getFormatterData(data.seriesId, data.marker)}`
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>

@import '../../css/select.scss';
@import '../../css/index.scss';
.measure_point {
  background-color: rgba(46, 107, 176, 0.5) !important;
}
#history {
  height: 540px;
  width: 600px;
  left: 408px;
  top: 66px;
  border-radius: 4px;
  z-index: 1001;
  .time {
    width: 100%;
    margin: 10px 0;
  }
  .charts {
    height: 300px;
    padding: 5px;
    background-color: rgba(24, 41, 72, 0.5) !important;
  }
  /deep/ .el-table th.gutter {
    display: table-cell !important;
  }
}
.close-btn {
  top: 5px;
  right: 5px;
  z-index: 9999;
}
/deep/.el-card {
  height: calc(100% - 30px);
  &__body {
    padding: 0px !important;
    border-radius: 2px;
  }
}
/deep/ .el-date-editor .el-range-input {
  color: #ffffff;
  background-color: transparent;
}
/deep/ .el-range-editor--mini .el-range-separator {
  color: #ffffff;
}

</style>
